/**
 * @author Blurain
 * @description H5唤起APP组件，映射表：http:wiki.shopshops.top:8090/pages/viewpage.action?pageId=3216528；主播端目前没有需求，所以* 功能没做，架子其实已经有了，待实现。
 *
 * @function init // 唤起APP的主方法
 * @function download // 下载APP
 *
 * @param {Object} action // 传给app的参数：jumpType/jumpId/jumpUrl
 * @param {boolean} isLink // ios 是否使用univalsal link
 * @param {boolean} isCapp // 默认呼起Capp，false呼起Happ
 * @param {string} downUrl // 国内应用市场链接
 * @param {Object} downUrlEn // 国外应用市场
 * @param {boolean} auto // scheme 呼起APP失败后 是否自动跳转下载
 * @param {number} timeout // 超时时间
 *
 * @example
 *
 * const openApp = new OpenApp()
 * openApp.init({
 *  action:{
 *      jumpType:8,
 *      jumpId:'https://m.shopshops.top'
 *  }
 * })
 *
 * openApp.download()
 *
 * @returns {Object} 返回OpenApp类
 *
 * 应用宝链接
 * https://sensors.shopshops.top/r/Ss
 *
 * 英文版appstore地址
 * https://sensors.shopshops.top/r/vB
 *
 */
// import vm from '@/main'
import { plateForm } from '@/utils';

const { isAndroid, isIOS } = plateForm();

export const isChrome = navigator.userAgent.toLowerCase().match(/(Chrome|CriOS|GSA)/ig);

// 应用宝链接(打开app标签) 安卓环境直接下载
const YYB_HREF = isAndroid
  ? 'https://ss-static.shopshops.live/android/ShopShops.apk'
  : 'https://apps.apple.com/cn/app/shopshops%E5%93%AA%E9%80%9B-%E7%9B%B4%E6%92%AD%E7%9B%B4%E8%B4%AD%E4%BB%A3%E8%B4%AD%E5%B9%B3%E5%8F%B0/id1107585432';

// 英文版appstore地址
const enAppStoreUrl = 'https://apps.apple.com/cn/app/shopshops%E5%93%AA%E9%80%9B-%E7%9B%B4%E6%92%AD%E7%9B%B4%E8%B4%AD%E4%BB%A3%E8%B4%AD%E5%B9%B3%E5%8F%B0/id1107585432';

// 谷歌应用市场地址
const googleStoreUrl = isAndroid
  ? 'https://ss-static.shopshops.live/android/ShopShops.apk'
  : 'https://play.google.com/store/apps/details?id=com.shopshops.cn';

// 定义跨域域名
const MDOMAIN = 'https://m.shopshops.top';
const UDOMAIN = 'https://user-association.shopshops.top';
const HDOMAIN = 'https://host-association.shopshops.top';

// 获取真实的跨域链接
const _realLinkDomain = (u = window.location.href, isCapp = true) => {
  if (u.includes(MDOMAIN)) {
    if (isCapp) return UDOMAIN;
    return HDOMAIN;
  }
  return UDOMAIN;
};

// Capp配置 用户端
const CAPP_LINK = {
  linkUrl: `${_realLinkDomain()}/shopshops`,
  schemeUrl: 'shopshopsng://shopshops.top:8080/openOfH5',
};

// Happ配置 主播端
const HAPP_LINK = {
  linkUrl: `${_realLinkDomain()}/shopshopsHosts`,
  schemeUrl: '',
};

const lanEnv = false; //(target = 'zh-') => navigator.language.startsWith(target);
export default class OpenApp {
  constructor(
    opt = {
      action: {}, // 传给app的参数：jumpType/jumpId/jumpUrl
      isLink: true, // ios 是否使用univalsal link
      isCapp: true, // 默认呼起Capp，false呼起Happ
      downUrl: YYB_HREF, // 国内应用市场链接
      downUrlEn: {
        ios: enAppStoreUrl,
        android: googleStoreUrl,
      }, // 国外应用市场
      auto: true, // 呼起APP失败后 是否自动跳转下载
      autoJumpUrl: '', // 唤起APP失败后跳转到指定页面
      timeout: 3000, // 超时时间
      // callback: () => {
      //     // scheme协议 ios呼起APP失败后回调
      //     if (lanEnv()) {
      //         // eslint-disable-next-line no-alert
      //         alert('唤起APP失败，请确保已经安装APP并重新尝试唤起或者下载APP')
      //         return
      //     }
      //     // eslint-disable-next-line no-alert
      //     alert('Failed to call up the app, please try again')
      // }
    },
  ) {
    Object.assign(this, { ...opt });
    this._getEnv();
  }
  manualOpenInit(opt = {}){
      this.init({ 
          auto: isChrome,
          isLink: !isChrome,
          ...opt
      });
  }
  init(opt = {}) {
    Object.assign(this, { ...opt });
    // ios下 chrome用schema唤起，其他用通用链
    if (this.plateForm === 'ios' && !isChrome && this.isLink === true ) {
      // if (this.version - 9 >= 0 && this.isLink === true) {
        this._goUniversal();
        return;
      // }
    }
    this._goScheme();
  }

  download(opt = {}) {
    Object.assign(this, { ...opt });
    // if ((lanEnv() || this.plateForm === 'micromessenger') && this.downUrl) {
    //   console.log('跳转应用宝');
    //   if (isAndroid && this.plateForm === 'micromessenger') {
    //     return;
    //   }
    //   window.location.href = this.downUrl;
    //   return;
    // }
    const { ios: iosUrl, android: androidUrl } = this.downUrlEn;
    if (this.plateForm === 'ios' && iosUrl) {
      console.log('海外appstore');
      window.location.href = iosUrl;
      return;
    }
    if (isAndroid && androidUrl) {
      // 英文环境的安卓跳转到订单列表
      if (!lanEnv()) {
        window.location.href = `${window.location.origin}/order_list`;
        return;
      }
      if (this.plateForm === 'micromessenger') {
        return;
      }
      window.location.href = androidUrl;
    }
  }

  // universal link 方式拉起
  _goUniversal() {
    try {
      let target = this._getUrl(true);
      window.location.href = target
    } catch (e) {
      console.log(e);
    }
  }

  // scheme 方式拉起
  _goScheme() {
    window.location.href = this._getUrl();
    this._checkIsUp().then((res) => {
      // vm.$store.commit('SET_OVERLAY', false)
      if (res === 1) {
        // alert('跳转APP成功 打开');
        console.log('APP唤起成功');
      } else if (res === 0) {
        // alert('跳转APP失败 去下载')
        console.log('APP唤起失败');
        if (this.autoJumpUrl) {
          window.location.href = this.autoJumpUrl;
        }
        
        if (!this.auto) return;
        // if (this.plateForm === 'ios') {
        //     this.callback && this.callback()
        //     return
        // }
        this.download();
      }
    });
  }

  // scheme 方式拉起
  _share2Scheme(callback) {
    // const queryObj = this._getQueryObj();

    {
      const isSafari = /Safari/.test(navigator.userAgent)
        && !/Chrome/.test(navigator.userAgent)
        && !/CriOS/.test(navigator.userAgent)
        && !/GSA/.test(navigator.userAgent);
      if (!isSafari) {
        window.location.href = this._getUrl();
      }
      this._checkIsUp().then((res) => {
        // vm.$store.commit('SET_OVERLAY', false)
        if (res === 1) {
          // alert('跳转APP成功 打开');
          console.log('APP唤起成功');
        } else if (res === 0) {
          console.log('APP唤起失败');
        }
      });
    }

    // if (queryObj == null
    //           || queryObj.activityType != 'inviteCode') {
    //   callback();
    //   return;
    // }

    // sessionStorage.setItem('inviteInfo', JSON.stringify(queryObj));
    // callback ? callback(queryObj) : null;
    callback ? callback() : null;
  }

  // 获取对象参数
  _getQueryObj(url = window.location.href) {
    const params = {};
    const urls = url.split('?');
    const arr = urls[1] ? urls[1].split('&') : [];
    for (let i = 0, l = arr.length; i < l; i++) {
      const a = arr[i].split('=');
      params[a[0]] = a[1];
    }
    return params;
  }

  // 获取当前运行时环境
  _getEnv() {
    const u = navigator.userAgent.toLocaleLowerCase();

    // 微信环境
    if (u.indexOf('micromessenger') !== -1) {
      this.plateForm = 'micromessenger';
      this.version = u.match(/micromessenger\/(\d+\.*\d+)/i);
      return;
    }
    // IOS
    if (Boolean(u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i)) || u.indexOf('mac os x') > -1) {
      this.plateForm = 'ios';
      this.version = u.match(/OS(.*?)(\d+)/i)[2];
      return;
    }
    // Android
    if (u.match(/Android\s*(\d+)/i)) {
      this.plateForm = 'android';
      this.version = u.match(/Android\s*(\d+)/i)[1];
      return;
    }
    // 其他环境
    this.plateForm = 'anonymous';
  }

  // 获取 拉起APP的 完整协议链接
  _getUrl(isLink) {
    const {
      jumpType, jumpId, jumpUrl, fontRouterName,
    } = this.action;
    const param = (() => {
      if (jumpType) {
        if (jumpId) {
          return fontRouterName
            ? `?jumpType=${jumpType}&jumpId=${jumpId}&fontRouterName=${fontRouterName}`
            : `?jumpType=${jumpType}&jumpId=${jumpId}`;
        }
        if (jumpUrl) {
          return fontRouterName
            ? `?jumpType=${jumpType}&jumpUrl=${jumpUrl}&fontRouterName=${fontRouterName}`
            : `?jumpType=${jumpType}&jumpUrl=${jumpUrl}`;
        }
        return fontRouterName
          ? `?jumpType=${jumpType}&fontRouterName=${fontRouterName}`
          : `?jumpType=${jumpType}`;
      }
      return '';
    })();
    let linkUrl;
    let schemeUrl;
    if (this.isCapp) {
      linkUrl = CAPP_LINK.linkUrl;
      schemeUrl = CAPP_LINK.schemeUrl;
    } else {
      linkUrl = HAPP_LINK.linkUrl;
      schemeUrl = HAPP_LINK.schemeUrl;
    }
    return isLink ? `${linkUrl}${param}` : `${schemeUrl}${param}`;
  }

  // 检查是否拉起
  _checkIsUp() {
    return new Promise((resolve) => {
      let isChange = false;

      let property = 'hidden';
      let eventName = 'visibilitychange';
      if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        property = 'hidden';
        eventName = 'visibilitychange';
      } else if (typeof document.msHidden !== 'undefined') {
        property = 'msHidden';
        eventName = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        property = 'webkitHidden';
        eventName = 'webkitvisibilitychange';
      }

      const pageChange = (e) => {
        isChange = true;
        if (document[property] || e.hidden || document.visibilityState == 'hidden') {
          //  拉起APP成功处理
          this.timer && clearTimeout(this.timer);
          resolve(1);
        } else {
          //  拉起APP失败处理
          resolve(0);
        }
        document.removeEventListener(eventName, pageChange);
        document.removeEventListener('baiduboxappvisibilitychange', pageChange);
      };
      document.addEventListener(eventName, pageChange, false);
      document.addEventListener('baiduboxappvisibilitychange', pageChange, false);

      this.timer = setTimeout(() => {
        if (isChange) {
          this.timer && clearTimeout(this.timer);
          return;
        }
        document.removeEventListener(eventName, pageChange);
        document.removeEventListener('baiduboxappvisibilitychange', pageChange);

        if (!document.hidden && !isChange) {
          //  拉起APP失败处理
          resolve(0);
        } else {
          // Unknown逻辑，暂时跳转失败处理
          resolve(0);
        }
        isChange = true;
      }, this.timeout - 0);
    });
  }
}
